export interface GenerateRoutesRequest {
     planId  : string,
     planContainerId :string,
     connectionId :string
}